import styles from "./Aplicacao.module.css";
import load from "../../../../Images/loading.gif";
import { useEffect, useState } from "react";
import { Link, Navigate, Routes, Route, useLocation, useParams } from "react-router-dom";
import { FaPlay, FaPause } from "react-icons/fa6";
import { GrPowerReset } from "react-icons/gr";
import Timeline from "./Timeline/Timeline";
import ReportarBug from "./ReportarBug/ReportarBug";
import Versao from "./Versao/Versao";
import Pagamentos from "./Pagamentos/Pagamentos";
import Informacoes from "./Informacoes/Informacoes";

function Aplicacao({ user }) {
    const { appId } = useParams(); // ← pega o ID da URL
    const [venda, setVenda] = useState(null);
    const [invoice, setInvoice] = useState(false);
    const [loading, setLoading] = useState(true);
    const location = useLocation();


    const fetchVenda = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/sales/${appId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch sale");
            }

            const data = await response.json();
            setVenda(data[0]);
        } catch (error) {
            console.error("Erro ao buscar venda:", error);
            setVenda(null);
        } finally {
            setLoading(false);
        }
    };

    const fetchInvoice = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/faturas/pend/${appId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to invoice sale");
            }

            const data = await response.json();
            console.log(data)
            if (data.length === 0) setInvoice(false)
                else setInvoice(true);
        } catch (error) {
            console.error("Erro ao buscar invoice:", error);
            setInvoice(null);
        }
    };

    useEffect(() => {
        fetchVenda();
        fetchInvoice();
    });

    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!venda) {
        return <div className={styles.noData}>Venda não encontrada.</div>;
    }

    if (venda.userId !== user.id) {
        return <Navigate to="/dashboard" />;
    }

    console.log(invoice)
    return (
        <div className={styles.content}>
            <div className={`${styles.size} ${styles.dashboard}`}>
                <div className={styles.pageCurrent}>
                    <Link to={`/dashboard`}>
                        Painel de Controlo
                    </Link>
                    <span className={styles.separator}>{">"}</span>
                    <Link to={`/dashboard/aplicacoes`}>
                        Aplicações
                    </Link>
                    <span className={styles.separator}>{">"}</span>
                    <span className={styles.currentPage}>{venda.serviceName}</span>
                </div>
                <div className={styles.dashNavContent}>
                    {invoice !== false  && (
                        <div className={styles.notificacao}>Tem uma fatura por pagar relativamente a este serviço</div>
                    )}
                    <div className={styles.main}>
                        <div className={styles.image}>
                            <img src={`${venda.serviceImage}`} alt="Imagem da Aplicação" />
                        </div>
                        <div className={styles.data}>
                            <div className={styles.name}>{venda.serviceName}</div>
                            <div className={styles.id}>Online á 3 dias</div>
                            <div className={styles.role}><FaPlay /> <FaPause /> <GrPowerReset /> Reinstalar</div>
                        </div>
                    </div>
                    <div className={styles.pages}>
                        <span className={styles.pages}>
                            <Link to={`/dashboard/aplicacoes/${appId}/timeline`}><div className={`${styles.page} ${location.pathname === `/dashboard/aplicacoes/${appId}` || location.pathname === `/dashboard/aplicacoes/${appId}/timeline` ? styles.active : ""}`}>Timeline</div></Link>
                            <Link to={`/dashboard/aplicacoes/${appId}/reportarbug`}><div className={`${styles.page} ${location.pathname === `/dashboard/aplicacoes/${appId}/reportarbug` ? styles.active : ""}`}>Reportar Bug</div></Link>
                            <Link to={`/dashboard/aplicacoes/${appId}/versao`}><div className={`${styles.page} ${location.pathname === `/dashboard/aplicacoes/${appId}/versao` ? styles.active : ""}`}>Versão</div></Link>
                            <Link to={`/dashboard/aplicacoes/${appId}/pagamentos`}><div className={`${styles.page} ${location.pathname === `/dashboard/aplicacoes/${appId}/pagamentos` ? styles.active : ""}`}>Pagamentos</div></Link>
                            <Link to={`/dashboard/aplicacoes/${appId}/informacoes`}><div className={`${styles.page} ${location.pathname === `/dashboard/aplicacoes/${appId}/informacoes` ? styles.active : ""}`}>Informações</div></Link>
                        </span>
                    </div>
                    <div className={styles.pageContent}>
                        <Routes>
                            <Route index element={<Timeline />} />
                            <Route path="timeline" element={<Timeline app={appId} />} />
                            <Route path="reportarbug" element={<ReportarBug app={appId} />} />
                            <Route path="versao" element={<Versao app={appId} venda={venda} />} />
                            <Route path="pagamentos" element={<Pagamentos app={appId} />} />
                            <Route path="informacoes" element={<Informacoes app={appId} venda={venda} />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aplicacao;